// extracted by mini-css-extract-plugin
export default {"root":"Average_root__35NhA","content":"Average_content__UJ20w"};